/**
 * FANPLAZA — Recently Viewed Products
 * Tracks product handles in localStorage and renders cards via Section Rendering API.
 */
(function() {
  const STORAGE_KEY = 'rpt_recently_viewed';
  const MAX_STORED = 20;
  const SECTION_ID = 'fanplaza-recently-viewed-card';

  /**
   * Get stored handles from localStorage.
   */
  function getStoredHandles() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Save a product handle to recently viewed.
   * Most recent first, FIFO when exceeding MAX_STORED.
   */
  function trackProduct(handle) {
    if (!handle) return;
    let handles = getStoredHandles();
    /* Remove if already exists (will re-add at front) */
    handles = handles.filter(function(h) { return h !== handle; });
    handles.unshift(handle);
    /* Trim to max */
    if (handles.length > MAX_STORED) {
      handles = handles.slice(0, MAX_STORED);
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* Storage full or unavailable */
    }
  }

  /**
   * Fetch a server-rendered product card via the Section Rendering API.
   * Returns the HTML string or null on failure.
   */
  function fetchProductCard(handle) {
    return fetch('/products/' + handle + '?sections=' + SECTION_ID)
      .then(function(r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function(data) {
        if (!data || !data[SECTION_ID]) return null;
        /* Produkte ohne Bild rendern eine leere Karte — überspringen */
        if (data[SECTION_ID].indexOf('fp-rv__card') === -1) return null;
        return data[SECTION_ID];
      })
      .catch(function() { return null; });
  }

  /**
   * Web Component: fanplaza-recently-viewed
   */
  if (!customElements.get('fanplaza-recently-viewed')) {
    customElements.define('fanplaza-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        this.currentHandle = this.dataset.currentHandle || '';
        this.maxDisplay = parseInt(this.dataset.maxDisplay, 10) || 8;

        /* Track current product */
        if (this.currentHandle) {
          trackProduct(this.currentHandle);
        }

        this.loadProducts();
      }

      loadProducts() {
        var handles = getStoredHandles();
        /* Exclude current product */
        handles = handles.filter(function(h) { return h !== this.currentHandle; }.bind(this));
        /* Limit display count */
        handles = handles.slice(0, this.maxDisplay);

        if (handles.length === 0) return;

        var track = this.querySelector('.fp-rv__strip') || this.querySelector('.fp-featured-slider__track');
        if (!track) return;

        var self = this;
        var fetches = handles.map(function(handle) {
          return fetchProductCard(handle);
        });

        Promise.all(fetches).then(function(cards) {
          var html = '';
          cards.forEach(function(cardHtml) {
            if (cardHtml) {
              html += '<div class="fp-featured-slider__slide">' + cardHtml + '</div>';
            }
          });

          if (!html) return;

          track.innerHTML = html;
          self.style.display = '';
          self.initSlider();

          /* Re-init bookmarks if the global function exists */
          if (typeof window.rptInitBookmarks === 'function') {
            window.rptInitBookmarks();
          }
        });
      }

      initSlider() {
        var track = this.querySelector('.fp-rv__strip') || this.querySelector('.fp-featured-slider__track');
        var prevBtn = this.querySelector('.fp-featured-slider__arrow--prev');
        var nextBtn = this.querySelector('.fp-featured-slider__arrow--next');
        if (!track) return;
        if (!prevBtn || !nextBtn) return;

        function getSlideWidth() {
          var slide = track.querySelector('.fp-featured-slider__slide');
          return slide ? slide.offsetWidth : 300;
        }

        function updateArrows() {
          var scrollLeft = Math.round(track.scrollLeft);
          var maxScroll = track.scrollWidth - track.clientWidth;
          prevBtn.disabled = scrollLeft <= 1;
          nextBtn.disabled = scrollLeft >= maxScroll - 1;
        }

        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
        window.addEventListener('resize', updateArrows);
      }
    });
  }
})();
